import ForgotPasswordPage from '@/features/login/forgot-password/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/login/forgot-password')({
  component: ForgotPasswordPage,
})
